<section class="footer_container" id="footer">
  <div class="footer_padding">
    <hr>
    <div class="icons_section row">
      <div class="portal_footer_img col-sm-4 col-md-1">
        <img id="footerItauImg" src="assets/images/Logo-white.png" alt="{{copyService.copies.footer_logo_alt_image}}" />
      </div>
      <div class="brand_sections col-sm-4 col-md-11">
        <span id="footerInstagram" class="brand_icon icon-itaufonts_full_instagram"></span>
        <span id="footerVideo" class="brand_icon icon-itaufonts_full_video"></span>
        <span id="footerFacebook" class="brand_icon icon-itaufonts_full_facebook"></span>
        <span id="footerTwitter" class="brand_icon icon-itaufonts_full_twitter"></span>
      </div>
    </div>
  </div>

  <div class="footer_padding copyright">
    <div>
      <p id="footerBankName" class="bank_name">{{copyService.copies.footer_bank_name}}</p>
    </div>
    <div>
      <img id="footerSuperIntendImg" src="assets/images/logo-superintendencia.png" alt="{{copyService.copies.footer_logo_alt_image}}"/>
    </div>
  </div>
</section>
